/**
 * IME 変換中のキー入力か（日本語入力で Enter を変換の確定に使っている最中）。
 * 変換中の Enter は isComposing=true、または Safari などでは keyCode 229 で届く。
 * 検索欄の「Enter で開く・切り替える」はこのとき動かさない。
 *
 * @param {KeyboardEvent} event
 * @returns {boolean}
 */
export function isImeComposing(event) {
  return !!event && (event.isComposing === true || event.keyCode === 229)
}
